export const NAME = "name";
export const DESCRIPTION = "description";
export interface FilterType {
  orderBy: string;
  orderDirection: string;
  name?: string; // 👈 optional
}

export const DEFAULT_FILTER: FilterType = {
  
  orderBy: "updatedAt",
  orderDirection: "DESC",
};

